import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LuTrendingUp } from "react-icons/lu";
import { LuLayers } from "react-icons/lu";
import { LuGlobe } from "react-icons/lu";
import { LuGift } from "react-icons/lu";

const HomepageComp3 = () => {
  const { t } = useTranslation();
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entry.target);
      }
    });
  });

  useEffect(() => {
    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [ref]);

  return (
    <div className={`homepage-component-container2 homepage-comp3-container flex justify-center  ${isVisible ? 'fade-in' : ''}`} ref={ref}>

      <div className='homepage-comp3-div1 mt-4'>
        <h1 className='homepage-title2'>
          {t('homepage.comp3.title')}
        </h1>

        <div className='md:grid grid-cols-2 gap-12 mt-6'>
          <div className='flex gap-4'>
            <div className='homepage-comp3-icon'>
              <LuTrendingUp />
            </div>
            <div className=''>
              <h2 className='homepage-title3'>{t('homepage.comp3.service1.title')}</h2>
              <p className='homepage-text2'>{t('homepage.comp3.service1.desc')}</p>
            </div>
          </div>

          <div className='flex gap-4'>
            <div className='homepage-comp3-icon'>
              <LuLayers />
            </div>
            <div className=''>
              <h2 className='homepage-title3'>{t('homepage.comp3.service2.title')}</h2>
              <p className='homepage-text2'>{t('homepage.comp3.service2.desc')}</p>
            </div>
          </div>
        </div>

        <div className='md:grid grid-cols-2 gap-12 mt-6'>
          <div className='flex gap-4'>
            <div className='homepage-comp3-icon'>
              <LuGlobe />
            </div>
            <div className=''>
              <h2 className='homepage-title3'>{t('homepage.comp3.service3.title')}</h2>
              <p className='homepage-text2'>{t('homepage.comp3.service3.desc')}</p>
            </div>
          </div>

          <div className='flex gap-4'>
            <div className='homepage-comp3-icon'>
              <LuGift />
            </div>
            <div className=''>
              <h2 className='homepage-title3'>{t('homepage.comp3.service4.title')}</h2>
              <p className='homepage-text2'>{t('homepage.comp3.service4.desc')}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="parallax-container relative z-3">
        <div className="parallax-box"></div>
      </div>

    </div>
  )
}

export default HomepageComp3;